import { createFileRoute } from "@tanstack/react-router";
import * as db from "@/lib/db.server";

function page(html: string, status = 200) {
  return new Response(
    `<!doctype html><html><head><meta charset="utf-8"><title>Heallexa email preferences</title><meta name="viewport" content="width=device-width,initial-scale=1"/><style>body{margin:0;font-family:Inter,Arial,sans-serif;background:#f5f7fb;color:#0f172a}.card{max-width:480px;margin:64px auto;padding:32px;background:#fff;border-radius:12px;border:1px solid #e5e7eb}h1{font-size:20px;margin:0 0 12px}button{background:#0f172a;color:#fff;border:0;padding:12px 20px;border-radius:8px;font-weight:600;font-size:14px;cursor:pointer}p{line-height:1.6;font-size:15px;color:#334155}</style></head><body><div class="card">${html}</div></body></html>`,
    { status, headers: { "content-type": "text/html; charset=utf-8" } },
  );
}

export const Route = createFileRoute("/api/public/email/unsubscribe")({
  server: {
    handlers: {
      GET: async ({ request }) => {
        const url = new URL(request.url);
        const providerId = url.searchParams.get("provider");
        if (!providerId) return page("<h1>Invalid link</h1><p>This unsubscribe link is missing required information.</p>", 400);
        return page(
          `<h1>Unsubscribe from Heallexa emails?</h1>
           <p>You will stop receiving Heallexa provider upgrade emails. You can still sign in to your dashboard at any time.</p>
           <form method="POST"><input type="hidden" name="provider" value="${providerId}"/><button type="submit">Unsubscribe</button></form>`,
        );
      },
      POST: async ({ request }) => {
        const ct = request.headers.get("content-type") || "";
        let providerId: string | null = null;
        if (ct.includes("application/json")) {
          const body = await request.json().catch(() => ({}));
          providerId = (body as any)?.provider ?? null;
        } else {
          const form = await request.formData();
          providerId = (form.get("provider") as string) || null;
        }
        if (!providerId) return page("<h1>Invalid request</h1>", 400);

        const provider = await db.one(
          "SELECT id, email FROM public.providers WHERE id = $1",
          [providerId],
        );
        if (!provider?.email) return page("<h1>Profile not found</h1>", 404);

        await db.execute(
          `INSERT INTO public.provider_email_preferences
             (provider_id, email, unsubscribed_at, unsubscribe_reason)
           VALUES ($1, $2, $3, $4)
           ON CONFLICT (provider_id) DO UPDATE SET
             email = EXCLUDED.email,
             unsubscribed_at = EXCLUDED.unsubscribed_at,
             unsubscribe_reason = EXCLUDED.unsubscribe_reason`,
          [provider.id, provider.email, new Date().toISOString(), "user_link"],
        );

        await db.execute(
          `UPDATE public.email_sequence_enrollments
             SET status = $2, stop_reason = $3, completed_at = $4
           WHERE provider_id = $1 AND status = ANY($5)`,
          [
            provider.id,
            "stopped_unsub",
            "unsubscribed",
            new Date().toISOString(),
            ["active", "paused"],
          ],
        );

        return page("<h1>You're unsubscribed</h1><p>You will no longer receive these emails. If this was a mistake, contact contact@heallexa.com.</p>");
      },
    },
  },
  component: () => null,
});
